/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

// Named as times-circle-icon in ui system
export const CloseCircleIcon = ({
  className,
  style,
  color = '#938BB7',
  size = 16,
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM8 14.75C4.29063 14.75 1.25 11.7469 1.25 8C1.25 4.29063 4.25313 1.25 8 1.25C11.7094 1.25 14.75 4.25313 14.75 8C14.75 11.7094 11.7469 14.75 8 14.75ZM10.9625 5.83437L8.79688 8L10.9625 10.1656C11.1094 10.3125 11.1094 10.55 10.9625 10.6969L10.6969 10.9625C10.55 11.1094 10.3125 11.1094 10.1656 10.9625L8 8.79688L5.83437 10.9625C5.6875 11.1094 5.45 11.1094 5.30312 10.9625L5.0375 10.6969C4.89062 10.55 4.89062 10.3125 5.0375 10.1656L7.20312 8L5.0375 5.83437C4.89062 5.6875 4.89062 5.45 5.0375 5.30312L5.30312 5.0375C5.45 4.89062 5.6875 4.89062 5.83437 5.0375L8 7.20312L10.1656 5.0375C10.3125 4.89062 10.55 4.89062 10.6969 5.0375L10.9625 5.30312C11.1062 5.45 11.1062 5.6875 10.9625 5.83437Z"
        fill={color}
      />
    </svg>
  );
};
